import { Translate } from '@dreryk/react-common';
import { StyledFlex, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

import { TreatmentDaysCountTooltip } from './TreatmentDaysCountTooltip';

type NumericalDosageTextViewProps = {
   readonly treatmentDaysCount: number | undefined;
   readonly underTreatmentSupervision: boolean;
};

export const TreatmentDaysCountTextView = (props: NumericalDosageTextViewProps): JSX.Element => {
   const content = props.treatmentDaysCount ? (
      <TextSeparator separator={TextSeparatorType.SPACE}>
         <Text testId={'treatmentDaysCount'}>{props.treatmentDaysCount}</Text>
         <Text testId={'days'}>
            <Translate>{prescriptionTranslationKeys.numericalDosage.days}</Translate>
         </Text>
      </TextSeparator>
   ) : (
      <span>{'-'}</span>
   );

   const label = (
      <StyledFlex direction={'row'} alignItems={'center'}>
         <Translate>{prescriptionTranslationKeys.numericalDosage.treatmentDaysCount}</Translate>
         <TreatmentDaysCountTooltip underTreatmentSupervision={props.underTreatmentSupervision} />
      </StyledFlex>
   );

   return (
      <StyledPrescriptionTextView testId={'treatmentDaysCount'} compact label={label}>
         {content}
      </StyledPrescriptionTextView>
   );
};
